<script>
  import { Block } from "@urbaninstitute/dataviz-components";
  import Chart from "./Chart.svelte";
  import { createData } from "$utils/data.svelte.js";
  import { onMount } from "svelte";
  
    let toolData = createData();

  onMount(async () => {
    toolData.fetchData();
  });
</script>

<Block width="body">
      <h4>Microloans Generally Improve Business Outcomes, but Not for Every Entrepreneur</h4>
      <Chart dataFilter="Thriving" showAMetric={false} />
</Block>

